import React from "react";

import { PeopleCard, PeopleList } from "@caelor/ui";

import { OVERVIEW_DUMMY_DATA } from "./data";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import {
  PeopleCardOverviewContainer,
  PeopleContainer,
  PeopleOverviewContainer,
  PeopleTitle,
  PeopleWrapper,
} from "./styles";
import { MACRO_KEY } from "../../../../../defaults";
import { useUpcomingBirthdayStore } from "../../../../../../stores/use-upcoming-birthdays-store";
import { useStyleguideColors } from "../../../../../../hooks/use-styleguide-colors";
import { DEFAULT_ACCENT_COLOR } from "../../../../../../features/people/defaults";
import {
  buildTemplate,
  UPCOMING_BIRTHDAYS_TEMPLATES,
} from "./upcoming-birthday-templates";

const CardRender = ({ accent, borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "row", gap: 8 }}>
    <div style={{ width: 166 }}>
      <PeopleCard
        name="Ava Turner"
        avatarUrl="/img/peopleList.svg"
        emoji="🎉"
        subtitle="Jun 23"
        label="Today"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 166 }}>
      <PeopleCard
        name="Liam Brooks"
        avatarUrl="/img/peopleCard.svg"
        subtitle="Jun 30"
        label="7 Days"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
  </div>
);

const ListRender = ({ accent, borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "column", gap: 8 }}>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Angelica Lorens"
        avatarUrl="/img/peopleList.svg"
        emoji="🎉"
        subtitle="Jun 23"
        label="Today"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Liam Brooks"
        avatarUrl="/img/peopleCard.svg"
        subtitle="Jun 30"
        label="7 Days"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Ava Turner"
        avatarUrl="/img/peopleList.svg"
        subtitle="Aug 23"
        label="7 Days"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
  </div>
);

const VIEWS = {
  card: { label: "Card", View: CardRender },
  list: { label: "List", View: ListRender },
};

export const OverviewTemplates = () => {
  const { setMacro, setDrawers, colorPalette, styleguideSetup } =
    useOpticsStore((state) => ({
      setMacro: state.setMacro,
      setDrawers: state.setDrawers,
      colorPalette: state.colorPalette,
      styleguideSetup: state.styleguideSetup,
    }));

  const setData = useUpcomingBirthdayStore((state) => state.setData);

  const borderRadius = styleguideSetup?.cornerRadius || 3;

  return (
    <PeopleOverviewContainer
      onClick={() => {
        setMacro({ key: MACRO_KEY.UPCOMING_BIRTHDAYS });
        setData({ ...buildTemplate("card", borderRadius) });
        setDrawers({ templates: false, settings: true });
      }}
    >
      {OVERVIEW_DUMMY_DATA.map((person) => (
        <PeopleCardOverviewContainer>
          <PeopleCard
            name={person.name}
            avatarUrl={person.avatarUrl}
            subtitle={person.subtitle}
            emoji={person?.emoji}
            label={person.label}
            accentColor={colorPalette?.accent}
            borderRadius={borderRadius}
          />
        </PeopleCardOverviewContainer>
      ))}
    </PeopleOverviewContainer>
  );
};

const UpcomingBirthdayTemplates = () => {
  const { setData, data } = useUpcomingBirthdayStore((state) => ({
    setData: state.setData,
    data: state.data,
  }));
  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  const color =
    data?.accentColor || styleguideColors?.accent || DEFAULT_ACCENT_COLOR;

  const borderRadius = data?.borderRadius || styleguideSetup?.cornerRadius || 3;

  const buildData = (template, value) => {
    if (Object.keys(data || {}).length) {
      return {
        ...data,
        view: value.view,
      };
    }

    return {
      ...template,
      ...value,
    };
  };

  return (
    <PeopleContainer>
      {UPCOMING_BIRTHDAYS_TEMPLATES.map((template) => {
        const { label, View } = VIEWS[template.view];
        return (
          <PeopleWrapper
            key={template.id}
            onClick={() => {
              setData({
                ...buildData(template, {
                  accentColor: color,
                  borderRadius,
                  view: template.view,
                }),
              });
              setDrawers({ templates: false, settings: true });
            }}
          >
            <PeopleTitle>{label}</PeopleTitle>
            <View accent={color} borderRadius={borderRadius} />
          </PeopleWrapper>
        );
      })}
    </PeopleContainer>
  );
};

export default UpcomingBirthdayTemplates;
